// The read model stores the absence boundaries as ISO strings, while the zod schemas type them as Date.
type AbsenceInterval = {
    absenceFrom: Date | string;
    absenceUntil: Date | string;
};

const toTime = (value: Date | string) => (value instanceof Date ? value : new Date(value)).getTime();

export const isAbsenceActiveAt = (absence: AbsenceInterval, atMs: number) =>
    toTime(absence.absenceFrom) <= atMs && toTime(absence.absenceUntil) >= atMs;

export const hasActiveAbsence = (absences: Array<AbsenceInterval> | null | undefined, atMs: number = Date.now()) =>
    (absences ?? []).some((absence) => isAbsenceActiveAt(absence, atMs));
